import { useEffect, useRef } from 'react';

export function CheckboxCell({ indeterminate, checked = false, onClick = () => {} }) {
  const ref = useRef();

  useEffect(() => {
    ref.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <div className="relative z-1 checkbox hidden lg:flex items-center justify-center cursor-pointer">
      <input
        ref={ref}
        onChange={e => onClick(e.target.checked)}
        checked={checked}
        type="checkbox"
        className="h-4 w-4 rounded cursor-pointer"
      />
    </div>
  );
}
